import React, { Fragment } from "react";
import DataGrid from '@dataGrid';
import GridConfig from "./ibplanningSummaryGridConfig";
import { withStyles } from "@material-ui/core";
import styles from "../../Settings/styles";
import SaveAltSharp from "@material-ui/icons/SaveAltSharp";
import Tooltip from "../../../common/StyledToolTip";
import { formatDate } from '@dataGrid/gridUtilities';
import { csvFormulaInjectionSanitizer } from "../../../../utilities/csvUtils";
import SearchBox from "../../../common/SearchBox";

class IBPlanningSummaryGrid extends React.Component {
  constructor(props) {
    super(props);
    this.gridConfig = new GridConfig();
    this.gridApi = null;
    this.state = {
      quickFilterText: ""
    };
  }
  onGridReady = ({ api }) => {
    this.gridApi = api;
  };

  updateQuickFilterText = (quickFilterText) => {
    this.setState({quickFilterText});
  };

  exportCSV = () => {
    if (!this.props.data.length || !this.gridApi) {
      return;
    }
    const columnIds = this.gridApi.getColumns()
      .reduce((columnKeys, column) => {
        if (column.getColDef().headerName) {
          columnKeys.push(column.getColId());
        }
        return columnKeys;
      }, []);

    const planDate = this.props.data.find(
      terminals => terminals.planDate !== null
    ).planDate;
    const params = {
      fileName: `IBPlanning_Operations_Report_${formatDate({
        value: planDate
      })}`,
      columnKeys: columnIds,
      processCellCallback: (cell) => csvFormulaInjectionSanitizer(cell.value)
    };
    this.gridApi.exportDataAsCsv(params);
  };

  render() {
    const { config } = this.gridConfig;
    const { classes } = this.props;
    return (
      <Fragment>
        <header
          className={`${classes.moduleHeader} ${classes.reportsIBPlanningGridHeader}`}
        >
          <span>IB Planning Summary</span>
          <div className={`${classes.gridActionIcons} ${classes.searchBoxContainer}`}>
            <SearchBox onChange={this.updateQuickFilterText} customSearchClass = {classes.customSearchWidth200}/>
            <span onClick={this.exportCSV} className={classes.headerIconStyles}>
              <Tooltip title="Export Data">
                <SaveAltSharp />
              </Tooltip>
            </span>
          </div>
        </header>
        <div className={classes.reportsIBPlanningGridContainer}>
          <div className={`${classes.dataGrid} ${classes.anchorPointContent}`}>
            <DataGrid
              columnDefs={config.columns}
              config={config}
              rowData={this.props.data}
              enableSorting={config.enableSorting}
              onGridReady={this.onGridReady}
              quickFilterText={this.state.quickFilterText}
            />
          </div>
        </div>
      </Fragment>
    );
  }
}
export default withStyles(styles)(IBPlanningSummaryGrid);
